import { Vue, Component } from 'vue-property-decorator'
import PageHeader from '~/components/page/PageHeader'
import SectionHelper from '~/utils/sectionHelper'
import LinkItem from '~/types/LinkItem'
import ProductList from '~/components/block/ProductList'
import LinkPaginate from '~/components/element/LinkPaginate'
import ProductSlides from '~/components/block/ProductSlides'
import ImageElement from '~/components/element/ImageElement'
import HeaderType from '~/types/enum/HeaderType'
import FilterProduct from '~/components/block/filter/FilterProduct'
import SeoTextBlock from '~/components/block/SeoTextBlock'
import loc from '~/utils/loc'
import s from '~/utils/s'
import mainBreadcrumbsSubmenuItems from '~/utils/mainBreadcrumbsSubmenuItems'
import catalogSubmenuItems from '~/utils/catalogSubmenuItems'
import ResultBlock from '~/components/block/ResultBlock'
import ECertificate from '~/components/element/ECertificate'
import checkIframes from '~/components/setStylesForAddBanners'
import AD_FOX_CONSTANTS from '~/types/enum/AdFoxEnum'
import TagsCloud from '~/components/page/category/TagsCloud'

@Component
export default class CategoryPage extends Vue {
  isShow = true

  async mounted () {
    this.isShow = false
    // s(this.$store).categoryPage.loadCategoryFilters({ categoryId: s(this.$store).categoryPage.category.id, limit: 100 })
    await s(this.$store).advertising.addInfoInContainer(AD_FOX_CONSTANTS.inCatalog)
    // await s(this.$store).categoryPage.loadProducts()
    await s(this.$store).landingPage.loadTagsCloud(s(this.$store).categoryPage.category.id)
    setInterval(checkIframes, 100)
  }

  get breadcrumb (): LinkItem[] {
    const sections = s(this.$store).categoryPage.pathSections
    const helper = new SectionHelper(s(this.$store).general.sections, this.$store)
    const breadcrumb = sections.map((e) => {
      if (e.alternativeDisplay === false) {
        return {
          title: e.name,
          location: helper.getSectionPathById(e.id) ?? '/catalog',
          submenuItems: catalogSubmenuItems(this.$store, e.name)
        }
      } else {
        return {
          title: e.name,
          location: loc(this.$store, {
            name: 'categories-id',
            params: {
              id: e.id
            }
          }),
          submenuItems: catalogSubmenuItems(this.$store, e.name)
        }
      }
    })
    return [
      {
        title: 'Главная',
        location: loc(this.$store, {
          name: 'index'
        }),
        submenuItems: mainBreadcrumbsSubmenuItems(this.$store)
      },
      ...breadcrumb
    ]
  }

  get isShowPaginate (): boolean {
    return s(this.$store).categoryPage.pageCount > 1
  }

  get ferchLocation () {
    const route = { ...this.$route }
    const targetPage = s(this.$store).categoryPage.page + 2
    const query = route.query
    return {
      path: route.path,
      query: {
        ...query,
        page: targetPage.toString()
      }
    }
  }

  beforeDestroy () {
    s(this.$store).categoryPage.clearIsPreset()
  }

  renderPaginate () {
    if (this.isShowPaginate) {
      return (
        <div class="entity-list-block__content-paginate">
          <LinkPaginate {...{
            props: {
              pageCount: s(this.$store).categoryPage.pageCount,
              selected: s(this.$store).categoryPage.page
            }
          }} />
        </div>
      )
    }
  }

  renderLoadButton () {
    if (s(this.$store).categoryPage.page < s(this.$store).categoryPage.pageCount - 1) {
      return (
        <div class="entity-list-block__content-fetch">
          <nuxt-link {...{
            class: 'entity-list-block__content-fetch-button',
            props: {
              to: this.ferchLocation
            },
            nativeOn: {
              click: () => s(this.$store).categoryPage.enableLoadMore()
            }
          }}>
            Загрузить еще
          </nuxt-link>
        </div>
      )
    }
  }

  renderViewedProducts () {
    if (s(this.$store).categoryPage.viewedProducts.count > 0) {
      return (
        <div class="catalog-page__viewed-products">
          <div class="catalog-page__viewed-products-items">
            <ProductSlides {...{
              props: {
                products: s(this.$store).categoryPage.viewedProducts.items,
                title: 'Недавно просмотренные товары',
                isShowButton: false
              }
            }} />
          </div>
        </div>
      )
    }
  }

  renderCategoryInfo () {
    if (s(this.$store).categoryPage.category.img && s(this.$store).categoryPage.category.description) {
      return (
        <div class="catalog-page__category-info">
          <div class="catalog-page__category-info-container">
            <div class="catalog-page__category-info-row">
              <div class="catalog-page__category-info-col-image">
                <ImageElement {...{
                  props: {
                    img: s(this.$store).categoryPage.category.img
                  }
                }} />
              </div>
              <div class="catalog-page__category-info-col-text">
                <div class="catalog-page__category-info-description">
                  {
                    this.isShow

                      ? <div domPropsInnerHTML={s(this.$store).categoryPage.category.HTMLDescription ?? s(this.$store).categoryPage.category.description}></div>
                      : <truncate-collapsed {...{
                        props: {
                          length: 1000,
                          clamp: 'Показать еще',
                          type: 'html',
                          text: s(this.$store).categoryPage.category.HTMLDescription ?? s(this.$store).categoryPage.category.description,
                          less: 'Скрыть',
                          'action-class': 'catalog-page__show-more'
                        }
                      }} />
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    }
  }

  renderRegionText () {
    if (s(this.$store).categoryPage.category.RegionDescription) {
      return (
        <div class="catalog-page__category-info">
          <div class="catalog-page__category-info-container">
            <div class="catalog-page__category-info-row">
              <div class="catalog-page__category-info-col-image">
                {s(this.$store).categoryPage.category.RegionImg && <ImageElement {...{
                  props: {
                    img: s(this.$store).categoryPage.category.RegionImg
                  }
                }} />}
              </div>
              <div class="catalog-page__category-info-col-text">
                <div class="catalog-page__category-info-description">
                  {
                    this.isShow

                      ? <div domPropsInnerHTML={s(this.$store).categoryPage.category.RegionHTML ?? s(this.$store).categoryPage.category.RegionDescription}></div>
                      : <truncate-collapsed {...{
                        props: {
                          length: 1000,
                          clamp: 'Показать еще',
                          type: 'html',
                          text: s(this.$store).categoryPage.category.RegionHTML ?? s(this.$store).categoryPage.category.RegionDescription,
                          less: 'Скрыть',
                          'action-class': 'catalog-page__show-more'
                        }
                      }} />
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    }
  }

  render () {
    if (s(this.$store).categoryPage.category.name) {
      return (
        <div class="catalog-page">
          {(s(this.$store).regions.section?.eCertificate) &&
            <ECertificate/>
          }
          <div class="catalog-page__header">
            <PageHeader {...{
              props: {
                typeHeader: HeaderType.Category,
                breadcrumb: this.breadcrumb
              }
            }} />
          </div>
          <div class="catalog-page__content">
            <div class="entity-list-block">
              <div class="entity-list-block__content">
                <div class="entity-list-block__content-row">
                  <div class="entity-list-block__content-col-filter">
                    <FilterProduct {...{
                      props: {
                        store: s(this.$store).categoryFilter
                      }
                    }} />
                  </div>
                  <div {...{
                    class: {
                      'entity-list-block__content-col-product': true,
                      'entity-list-block__content-col-product-adaptive': s(this.$store).categoryPage.category.isPreset
                    }
                  }}>
                    <TagsCloud />
                    <div class="entity-list-block__content-product-row">
                      <div {...{
                        class: {
                          'entity-list-block__content-product': true,
                          'entity-list-block__content-product-adaptive': s(this.$store).categoryPage.category.isPreset
                        }
                      }}>
                        <ProductList {...{
                          props: {
                            products: s(this.$store).categoryPage.category.items,
                            count: s(this.$store).categoryPage.category.count.toString(),
                            isShowAds: true
                          }
                        }} />
                      </div>
                      {this.renderLoadButton()}
                      {this.renderPaginate()}
                    </div>
                  </div>
                  {s(this.$store).categoryPage.category.isPreset &&
                  s(this.$store).categoryPage.dataResult.productIds.length > 0 &&
                    <ResultBlock {...{
                      props: {
                        item: {
                          total: s(this.$store).categoryPage.dataResult.total,
                          totalSum: s(this.$store).categoryPage.dataResult.totalSum,
                          discount: s(this.$store).categoryPage.dataResult.discount,
                          totalDiscountPrice: s(this.$store).categoryPage.dataResult.totalDiscountPrice,
                          productIds: s(this.$store).categoryPage.dataResult.productIds
                        }
                      }
                    }}/>
                  }
                </div>
              </div>
            </div>
            {this.renderViewedProducts()}
            {this.renderCategoryInfo()}
            {this.renderRegionText()}
          </div>
          <SeoTextBlock />
        </div>
      )
    }
  }
}
